var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-box"},[_c('img',{staticClass:"avatar",attrs:{"src":_vm.avatarUrl || _vm.defaultUrl}}),_c('span',{staticClass:"text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }